// extracted by mini-css-extract-plugin
export default {"main":"CheckupVideoLander_main__hWpMx"};